<p className='post-item-tags'>
  <i className='fa fa-tags'></i>
  {tags.map((t, i)=> {
      const comma = i !== tags.length - 1 ? <span>, </span> : '';
      return <Link key={i} to='/' query={{tag: t}}>{t}{comma}</Link>;
    })}
</p>



/** WEBPACK FOOTER **
 ** ./htmls/tag.html
 **/